<template>
  <div class="main-body">
    <div class="header">扣款记录</div>
    <div class="out">

      <div class="search2">

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right: 5px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-date-picker
              v-model="dayString"
              type="date"
              style="margin-right:5px;width:150px;"
              value-format="yyyy-MM-dd"
              placeholder="开始日期" class="search">
          </el-date-picker>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border>

        <el-table-column prop="elderlyName" label="残疾人"></el-table-column>
        <el-table-column prop="lessBalance" label="扣款"></el-table-column>
        <el-table-column prop="afterBalance" label="扣款后"></el-table-column>
        <el-table-column prop="beforeBalance" label="扣款前"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleStatus(scope.row)">扣款历史</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <ElderlyLessRecord ref="myElderlyLessRecord" v-show="showModalDeal" v-on:closeElderly="closeElderly" v-on:getList="getList"></ElderlyLessRecord>

  </div>
</template>

<script>

import ElderlyLessRecord from '../Ins/ElderlyLessRecord';

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "Page",
  data(){
    return{

      tableLoading:false,

      showModalDeal:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,


      dayString:'',


      type:1,

      arr_ins:[],
      institutionCode: '',

    }
  },
  components:{
    ElderlyLessRecord
  },
  created(){

    this.th = this.$store.state.tableHeight;

    let dt = new Date();
    dt = dt.setDate(dt.getDate()-1);
    dt=new Date(dt);

    let m = dt.getMonth()+1;
    if(m<10){
      m = "0"+m;
    }
    let d = dt.getDate();
    if(d<10){
      d = "0"+d;
    }

    this.dayString = dt.getFullYear()+"-"+m+"-"+d;

    this.getIns();


  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },



    handleStatus(row){
      this.showModalDeal = true;
      this.$refs.myElderlyLessRecord.init(row.elderlyCode,row.elderlyName);
    },
    closeElderly(){
      this.showModalDeal = false;
    },

    timefilter(row,index,column){
      return timefilters(column)
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {

      if(isSearch)this.currentPage=1

      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"LessDay/GovPageIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          dayString:this.dayString,
        }
      }).then( (response)=> {
        //console.log(response);
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

</style>
